import { AxiosInstance } from "axios";

export interface CommunityRequest {
  solicitation_id: string;
  solicitation_title: string;
  created_at: string; // ISO 8601 date string
  evidence_platform: string;
  agency_name: string;
  agency_uuid: string;
  video_submissions: number;
  post_url: string;
  city: string;
  state: string;
}

export const fetchCommunityRequests = (
  api: AxiosInstance
): Promise<{ data: CommunityRequest[] }> => {
  return api.get("/community_requests");
};
